module.exports = __webpack_public_path__ + "img/index_quyigui.c420b377.png";